<div class="footer" [ngClass]="{'with-menu': withMenu}"
     fxLayout="row" fxLayoutAlign="space-evenly center" fxLayout.lt-lg="column"
     fxLayoutAlign.lt-lg="space-evenly center">
    <img src="assets/logo_footer.png" class="footer-logo" [alt]="'Logo'|i18n">
    <span *ngIf="version" class="footer-text">{{'Version: {0}'|i18n:version}}</span>
    <span class="footer-text"><b>{{copyright}}</b></span>
    <div class="new-line footer-text">
        {{address}}
    </div>
    <div *ngIf="!isCustomerCareSelected && customerCareEnabled|async">
        <button app-ghost-button (click)="onClickSupport()">
            <app-icon name="fal-question-circle"></app-icon>
            <div>{{'Customer support'|i18n}}</div>
        </button>
    </div>
</div>
